module.exports = __webpack_public_path__ + "img/system.ab79f077.png";